import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDateTime } from "../lib/api";
import { PageTitle, Panel, btnPrimary } from "./ui";

export default function LaunchContent() {
  const [d, setD] = useState(null);
  const [denied, setDenied] = useState(false);
  const load = () => api.get("/admin/launch-content").then((r) => setD(r.data)).catch((e) => { if (e?.response?.status === 403) setDenied(true); else toast.error(errMsg(e)); });
  useEffect(() => { load(); }, []);
  if (denied) return <p className="text-sm" data-testid="launch-denied">Ova operacija je dostupna samo SUPER_ADMIN korisniku.</p>;
  if (!d) return <p className="text-sm">Učitavanje…</p>;
  const run = async () => { try { const { data } = await api.post("/admin/launch-content/run"); toast.success(`Objavljeno ${data.published.length}, arhivirano demo ${data.archived_demos.length}`); load(); } catch (e) { toast.error(errMsg(e)); } };
  const c = d.counts;
  return (
    <div data-testid="launch-content">
      <PageTitle title="Početni sadržaj (lansiranje)" sub="Jednokratna operacija: arhivira demo tekstove (uz snimak) i objavljuje izvorno utemeljene članke."
        actions={<button onClick={run} className={btnPrimary} data-testid="launch-run">Pokreni / provjeri ponovo</button>} />
      <p className="text-sm" data-testid="launch-counts">Objavljeni članci: <b>{c.published_articles}</b> · objavljeni vodiči: <b>{c.published_guides}</b> · nacrti: <b>{c.drafts}</b> · čeka stručni pregled: <b>{c.awaiting_editorial_review}</b> · javni demo: <b>{c.demo_public}</b> · cilj: {c.target}</p>
      <Panel title="Objavljeni članci iz lansiranja" className="mt-6" testId="launch-articles">
        <ul className="space-y-3 text-sm">{d.articles.map((a) => (
          <li key={a.id} data-testid={`launch-article-${a.slug}`}>
            <a href={a.url} target="_blank" rel="noreferrer" className="font-semibold underline">{a.headline}</a> <span className="text-xs text-muted-foreground">{a.status} · {fmtDateTime(a.published_at)}{a.launch.editorial_review_required ? " · visok uticaj – čeka stručni pregled" : ""} · zamjenjuje: {a.launch.replaces_demo}</span>
            <div className="text-xs text-muted-foreground">Izvori: {a.sources.map((s) => <a key={s.url} href={s.url} target="_blank" rel="noreferrer" className="mr-2 underline">{s.title}</a>)}</div>
          </li>))}</ul>
      </Panel>
      <Panel title="Dnevnik" className="mt-6" testId="launch-log">
        <ul className="text-xs">{d.log.map((l) => <li key={l.id}>{fmtDateTime(l.at)} · {l.by} · {l.action} · {l.items.length}</li>)}</ul>
      </Panel>
    </div>
  );
}
